import { render, staticRenderFns } from "./AddToGroup.vue?vue&type=template&id=540106ee"
import script from "./AddToGroup.vue?vue&type=script&lang=js"
export * from "./AddToGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports